module.exports = __webpack_public_path__ + "img/portrait-039.f39c2052.jpg";